import { AnalyticsBrowser } from '@segment/analytics-next';

import { getAuthenticatedUser } from '../AuthenticationService';
import ConsentService, { ConsentCategory } from '../ConsentService';
import {
  getAllEnabled as getAllEnabledFeatureFlags,
  getAll as getAllFeatureFlags,
  get as getFeatureFlag,
  FeatureFlag,
} from '../FeatureFlagService';

export const initialize = () => {
  const { accountId, employeeId, uuid } = getAuthenticatedUser();
  const isTrackingEnabled =
    environment.TRACKING_ENABLED && ConsentService.isCategoryConsented(ConsentCategory.Necessary);

  let analytics: AnalyticsBrowser;

  if (isTrackingEnabled) {
    analytics = new AnalyticsBrowser();

    // @ts-ignore type provided by library does not match what we need.
    window.analytics = analytics;

    analytics.load({ writeKey: environment.TRACKING_SECRET });
    analytics.page();

    analytics.reset();

    const identifyPayload: Record<string, TSFixMe> = {
      id: uuid,
      email: uuid, // not really passing the email, but this property is used by inmoment (aka wootric) to identify the user, but it can also be an id instead of an email.
      account_id: accountId,
      teamleaderOffice: window.top!.TLGLOBALS.TLOFFICE,
      activationTimestamp: window.top!.TLGLOBALS.ACTIVATION_TIMESTAMP,
      createdAt: window.top!.__INITIAL_STATE__.account.createdAt, // necessary for inmoment (aka wootric)
      language: window.top!.TLGLOBALS.LANGUAGE,
      modules: window.top!.__INITIAL_STATE__.user.accessibleModules,
      maxAmountOfEmployees: window.top!.TLGLOBALS.MAX_AMOUNT_OF_EMPLOYEES,
      demo_account: window.top!.TLGLOBALS.IS_DEMO_ACCOUNT,
      sandboxAccount: window.top!.__INITIAL_STATE__.account.isSandbox,
      impersonating: window.top!.TLGLOBALS.IMPERSONATING,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
      },
      window: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
    };

    if (getFeatureFlag(FeatureFlag.AlternativeSegmentFeatureFlags, false) === true) {
      identifyPayload.featureFlagValues = getAllFeatureFlags();
    } else {
      identifyPayload.featureFlags = getAllEnabledFeatureFlags();
    }

    analytics.identify(`${employeeId}`, identifyPayload);

    analytics.group(`${accountId}`, {
      accountModuleList: window.top!.__INITIAL_STATE__.user.features,
    });
  }
};

export const track = (event: string, source: string, meta = {}) => {
  const isTrackingEnabled =
    environment.TRACKING_ENABLED && ConsentService.isCategoryConsented(ConsentCategory.Necessary);

  if (typeof source !== 'string') {
    throw new Error('Source is required for tracking');
  }
  if (isTrackingEnabled) {
    window.analytics.track(event, { source, ...meta });
  } else {
    // eslint-disable-next-line no-console
    console.log('tracked  ', event, { source, ...meta });
  }
};
